import {Component, HostBinding, Input} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-form-radio-buttons',
    template: `
        <label *ngFor="let item of values;"
               class="form-radio-buttons__button"
               (click)="onClick(item)"
               [class._disabled]="item.disabled"
               [class._active]="fbControl.value === item.value"
               [attr.title]="item.hoverMessage || null"
        >{{item.title}}</label>
    `,
    styles: [`
        :host {
            display: block;
        }
    `]
})

export class FormRadioButtonsComponent {
    @Input() fbControl: FormControl;
    @Input() values: RadioValueInterface[] = [];

    @HostBinding('class') className = 'form-radio-buttons';

    onClick(item: RadioValueInterface) {
        if (item.disabled) {
            return;
        }

        this.fbControl.patchValue(item.value);
    }
}

export interface RadioValueInterface {
    value: any;
    title: string;
    disabled?: boolean;
    hoverMessage?: string;
}
